import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { NavigationService } from 'src/app/services/navigation.service';
import { CustomerRequestDataService } from 'src/app/services/customer-request-data.service';
import { UserdataService } from 'src/app/services/userdata.service';
import { RegisterDataService } from 'src/app/services/register-data.service';
import { NotificationService } from 'src/app/services/notification-service';
import { ResellerService } from 'src/app/services/reseller.service';
import { CrudStatusType } from 'src/app/enum/crud-status-type';

@Component({
  selector: 'app-manage-reseller-add',
  templateUrl: './manage-reseller-add.component.html',
  styleUrls: ['./manage-reseller-add.component.scss']
})
export class ManageResellerAddComponent implements OnInit {
  form: FormGroup;
  paramsid: any;
  userDetails: any = {};
  addCondition: boolean = false;

  constructor(private navigate: NavigationService,
    private fb: FormBuilder,
    public dialog: MatDialog,
    public CustomerRequestDataService: CustomerRequestDataService,
    private ResellerService: ResellerService,
    private activateroute: ActivatedRoute,
    private RegisterDataService: RegisterDataService,
    private toastr: NotificationService
  ) {
    this.activateroute.params.subscribe((params: any) => {
      this.paramsid = parseInt(params.id);
    });
  }

  ngOnInit(): void {
    this.initializeValidators();
    if (this.paramsid > 0) {
      this.getFormDetails();
    }
    else {
      this.addCondition = true;
    }
  }

  initializeValidators() {
    this.form = this.fb.group({
      resellerName: ['', [Validators.required, Validators.pattern(/\S/)]],
      resellerCode: ['', [Validators.required, Validators.pattern(/\S/)]],
      IsAddOrUpdateInReach: [false],
    });
  }

  getFormDetails() {
    this.ResellerService.getResellerById(this.paramsid).subscribe((res) => {
      this.userDetails = res;
      this.form.patchValue({
        ...res,
        IsAddOrUpdateInReach: res.presentInPrepaid
      });
    });
  }

  goToManageReseller() {
    this.navigate.goToManageReseller();
  }

  onsubmit() {
    debugger
    if (this.form.valid) {
      const IsAddOrUpdateInReach = !!this.form.get('IsAddOrUpdateInReach')?.value;
      let payload: any = {
        ...this.userDetails,
        ...this.form.value,
        isAddOrUpdateInReach: IsAddOrUpdateInReach
      };
      // remove internal form flag if present
      if (payload.hasOwnProperty('IsAddOrUpdateInReach')) {
        delete payload.IsAddOrUpdateInReach;
      }
      this.ResellerService.saveReseller(payload).subscribe((res) => {
        if (res.crudStatus === CrudStatusType.ExceptionExists) {
          this.toastr.showError(res.additionalInfo);
        }
        else if (res.crudStatus === CrudStatusType.DataAddedSuccessfully) {
          this.toastr.showSuccess("Added successfully!");
          this.goToManageReseller();
        }
        else if (res.crudStatus === CrudStatusType.DataUpdatedSuccessfully) {
          this.toastr.showSuccess("Updated successfully!");
          this.goToManageReseller();
        }
      });
    } else {
      this.form.markAllAsTouched();
      this.toastr.showError("Please fill in all mandatory fields!")
    }
  }

}
